import React, { Fragment, useCallback } from 'react';

import PropTypes from 'prop-types';

import Tippy from '@tippyjs/react';
import { get, size } from 'lodash';

import ErrorMessages from 'components/ErrorMessages';

import { CheckboxField } from 'containers/Form/fields';

import { showIf } from './index';
import Observacoes from './Observacoes';

import 'tippy.js/dist/tippy.css';

const Pergunta = ({
	data,
	definicao,
	pergunta,
	required,
	disabled: disabledProps,
	readOnly,
	errors,
	usuarioInterno,
	onChangeHandler
}) => {
	/* REDUX */

	const { superLabel, label, observacoes, avisos, id: name, stackedOptions } = pergunta;

	const options = (pergunta.options || []).map(option => ({
		...option,
		descricao: `${option.descricao}`
	}));
	const warning = disabledProps ? 'Desabilitado por que documentos obrigatórios ainda não foram fornecidos' : null;

	const value = data?.[pergunta.id];
	const valueAlteradaRevisor = usuarioInterno ? null : data?.[`${pergunta.id}AlteradaRevisor`];
	const valueAlteradaRt = usuarioInterno ? data?.[`${pergunta.id}AlteradaRt`] : null;

	const onChangeRadio = e => {
		const { name, value: codigo } = e.target;
		onChangeHandler(codigo, name);
	};

	const onChangeText = (value, name, type) => {
		const aux = type.split('-');
		if (aux.length > 1) {
			type = aux[1];
		}
		if (type === 'email') {
			// Remove caracteres inválidos
			value = value.replace(/[^a-zA-Z0-9@._%+-]/g, '');

			// Permitir só um arroba
			const partes = value.split('@');
			if (partes.length > 2) {
				return;
			}
		} else if (type === 'telefone') {
			value = value.replace(/\D/g, '');
			if (value.length > 11) {
				return;
			}
			if (value.length === 9) {
				// formatar com a máscara 99999-99999
				value = value.replace(/(\d{5})(\d{4})/, '$1-$2');
			}
			if (value >= 10) {
				// formatar com a máscara (99) 9999-9999 ou (99) 99999-9999
				value = value.replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3');
			}
		} else if (type === 'cpfCnpj') {
			value = value.replace(/\D/g, '');
			if (value.length > 14) {
				return;
			}
			if (value.length === 14) {
				// formatar com a máscara 99.999.999/9999-99
				value = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
			} else if (value.length === 11) {
				// formatar com a máscara 999.999.999-99
				value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
			}
		} else if (type.startsWith('numero')) {
			const frac = type.replace('numero', '');
			const decimals = frac ? parseInt(frac, 10) : 0;
			value = value.replace(/\D/g, '');
			if (size(value) > 0 && parseFloat(value.replace('.', '').replace(',', '.')) > 0) {
				const formatter = Intl.NumberFormat('pt-BR', {
					style: 'decimal',
					minimumFractionDigits: decimals,
					maximumFractionDigits: decimals
				});
				value = formatter.format(parseInt(value) / 10 ** decimals);
			}
		}
		onChangeHandler(value, name);
	};

	const resposta = (options || []).reduce((acc, o) => {
		const codigo = typeof o === 'object' ? o.codigo : o;
		const descricao = typeof o === 'object' ? o.descricao : o;
		return value === codigo ? descricao : acc;
	}, null);

	const getDescricao = useCallback(
		(options, valor) => (options || []).find(o => o.codigo === valor)?.descricao || valor,
		[]
	);

	return readOnly & !resposta ? null : (
		<>
			<div className={`${readOnly ? 'row container-resposta-ap' : ''}`}>
				<div>
					{/* <span className="numero">{numero}</span> */}
					{superLabel && <div className="super-label">{superLabel}</div>}
					{label && (
						<div className="label">
							{label}
							{required && <span className="required">*</span>}
							{pergunta.tooltip && (
								<>
									{' '}
									<Tippy
										placement="bottom"
										trigger="click"
										hideOnClick={true}
										content={
											<div className="observacoes" style={{ minWidth: '500px' }}>
												<span className="warning">{pergunta.tooltip}</span>
											</div>
										}
									>
										<i className="fa fa-info-circle" style={{ color: '#fa970f', fontSize: '1.1rem' }} />
									</Tippy>
								</>
							)}
							{avisos && showIf(data, definicao, pergunta.showIf, `aviso ${pergunta.id}`) && (
								<div className="pergunta-warning">{avisos}</div>
							)}
						</div>
					)}
				</div>
				{readOnly && <>{readOnly && <span className="resposta-ap">{resposta || 'não respondido'}</span>}</>}
			</div>
			{!readOnly && (pergunta.type || size(pergunta.options) > 0) && (
				<div className="row linha-opcoes-resposta">
					<div className="form-group col-md-12" style={{ paddingLeft: '0' }}>
						{pergunta.type?.startsWith('text') ? (
							<input
								type="text"
								className="form-control"
								name={name}
								value={value || ''}
								onChange={e => onChangeText(e.target.value, name, pergunta.type)}
								readOnly={readOnly}
								disabled={disabledProps}
							/>
						) : pergunta.type === 'checkbox' ? (
							<CheckboxField
								value={value || []}
								name={name}
								options={options}
								readOnly={readOnly}
								disabled={disabledProps}
								onChangeHandler={({ name, value }) => {
									if (name !== 'errors') {
										onChangeHandler(value, name);
									}
								}}
								errors={errors}
								stacked={true}
							/>
						) : (
							<div style={stackedOptions ? { display: 'flex', flexDirection: 'column', marginBottom: '7px' } : {}}>
								{options.map(o => {
									const codigo = typeof o === 'object' ? o.codigo : o;
									const descricao = typeof o === 'object' ? o.descricao : o;
									const descricaoComplementar = typeof o === 'object' ? o.descricaoComplementar : o;
									const observacao = o.observacao;
									const disabled = typeof o === 'object' ? o.disabled || false : false;
									const defaultValue = typeof o === 'object' ? o.defaultValue || false : false;
									if (defaultValue && !value) {
										onChangeRadio({ target: { name, value: codigo } });
									}
									return (
										<Fragment key={codigo}>
											<div className="form-check form-check-inline" key={codigo}>
												<input
													type="radio"
													value={codigo}
													id={`radio-${name}-${codigo}`}
													name={name}
													onClick={onChangeRadio}
													readOnly={readOnly}
													disabled={disabled || disabledProps}
													onChange={() => false}
													checked={value === codigo}
													className="form-check-input"
												/>
												<label htmlFor={`radio-${name}-${codigo}`} className="form-check-label">
													<span>{descricao}</span>
													{descricaoComplementar && <div style={{ fontSize: 'small' }}>{descricaoComplementar}</div>}
												</label>
											</div>
											{observacao && value === codigo && (
												<div style={{ marginTop: '5px' }}>
													{' '}
													<span style={{ fontSize: '14px', fontWeight: 'bold', whiteSpace: 'pre-wrap' }}>
														{observacao}
													</span>
												</div>
											)}
										</Fragment>
									);
								})}
							</div>
						)}
						{size(observacoes) > 0 && (
							<Observacoes observacoes={observacoes} data={data} definicao={definicao} debugId={pergunta.id} />
						)}
						{valueAlteradaRevisor && (
							<div className="pergunta-warning">
								Valor alterado pelo revisor de {getDescricao(options, valueAlteradaRevisor.de)} para{' '}
								{getDescricao(options, valueAlteradaRevisor.para)}
							</div>
						)}
						{valueAlteradaRt && (
							<div className="pergunta-warning">
								Valor alterado pelo RT de {getDescricao(options, valueAlteradaRt.de)} para{' '}
								{getDescricao(options, valueAlteradaRt.para)}
							</div>
						)}
						{size(errors) > 0 && <ErrorMessages errorList={get(errors, name, false)} />}
						{size(warning) > 0 && (
							<div className="pergunta-warning">
								<i className="fa fa-exclamation-triangle" />
								<span>{warning}</span>
							</div>
						)}
					</div>
				</div>
			)}
		</>
	);
};
Pergunta.displayName = 'Pergunta';

Pergunta.propTypes = {
	data: PropTypes.object,
	definicao: PropTypes.string,
	pergunta: PropTypes.object,
	required: PropTypes.bool,
	readOnly: PropTypes.bool,
	disabled: PropTypes.bool,
	usuarioInterno: PropTypes.bool,
	onChangeHandler: PropTypes.func,
	errors: PropTypes.any
};
export default Pergunta;
